export default __webpack_public_path__ + "static/media/leon_c2.c58c15e8.jpg";